import { ActionIcon } from "@mantine/core";
import { FloppyDiskIcon, IconProps, PencilIcon, XIcon } from "@phosphor-icons/react";
import { ComponentProps, useMemo } from "react";

type ExpeditionActionsBaseProps = {
  state: { loading?: boolean; active: boolean };
  actions: {
    cancel: () => void;
    save: () => void;
    toggleActive?: () => void;
  };
  component?: {
    Icon: { Save: React.ElementType<IconProps>; Cancel: React.ElementType<IconProps> };
  };
  slots?: {
    Cancel?: ComponentProps<typeof ActionIcon>;
    Save?: ComponentProps<typeof ActionIcon>;
  };
};
export function ExpeditionActionsBase({ state, actions, component = { Icon: { Save: FloppyDiskIcon, Cancel: PencilIcon } }, slots }: ExpeditionActionsBaseProps) {
  const displayValues = useMemo(
    () => ({
      ariaLabel: state.active ? "Salvar" : "Editar",
      Icon: (props: IconProps) => (state.active ? <component.Icon.Save {...props} /> : <component.Icon.Cancel {...props} />),
      color: state.active ? "green" : "blue"
    }),
    [state.active]
  );

  const handleAction = () => {
    if (!state.active) {
      actions.toggleActive?.();
      return;
    }

    actions.save();
  };

  const handleCancel = () => {
    actions.cancel();
  };

  return (
    <>
      {state.active && (
        <ActionIcon aria-label="Cancelar ação" size="lg" radius="xl" color="red" onClick={handleCancel} variant="light" {...slots?.Cancel}>
          <XIcon />
        </ActionIcon>
      )}

      <ActionIcon
        aria-label={displayValues.ariaLabel}
        size="lg"
        radius="xl"
        color={displayValues.color}
        onClick={() => handleAction()}
        variant="light"
        loading={state.loading}
        {...slots?.Save}
      >
        <displayValues.Icon weight="bold" />
      </ActionIcon>
    </>
  );
}
